import { http, HttpResponse, PathParams } from 'msw';
import { apiUrl } from '../apiUrl';
import { AuthApiPaths } from '../../../slices/auth-api.slice';
import { userEmail, userFirstName, userId, userLastName } from '../../data/userInfo';
import { validPasscode } from '../../data/passcode';
import { authenticator } from '../../data/authenticator';
import { emailContact, phoneContact } from '../../data/contacts';
import { invitation, invitationWithoutLocale } from '../../data/invitation';
import { composeServerError, validateNewPassword, otpHandler, validateOtp } from './shared';

const enrollmentOtpSubmitMutation = http.post<PathParams, { passcode: string; contactId: string }>(
    apiUrl(AuthApiPaths.enrollmentEmailSubmit),
    async ({ request }) => {
        const body = await request.json();
        let response;
        if (body.passcode === validPasscode && body.contactId === emailContact.contactId) {
            response = HttpResponse.json({
                userId,
                userEmail,
                userFirstName,
                userLastName
            });
        } else {
            response = composeServerError(request, 'otpValidation');
        }
        return response;
    }
);

const enrollmentAuthenticatorVerifyMutation = http.post(apiUrl(AuthApiPaths.enrollmentAuthenticatorVerify), otpHandler);

const enrollmentAuthenticatorRegisterMutation = http.post(apiUrl(AuthApiPaths.enrollmentAuthenticatorRegister), () =>
    HttpResponse.json(authenticator)
);

// enrollment
const enrollmentEmailInitMutation = http.post(apiUrl(AuthApiPaths.enrollmentEmailInit), () => HttpResponse.json({}));

const enrollmentPasswordSubmitMutation = http.post<PathParams, { password: string }>(
    apiUrl(AuthApiPaths.enrollmentPasswordSubmit),
    async ({ request }) => {
        const body = await request.json();
        const { password } = body;
        const error = validateNewPassword(password);

        return error
            ? composeServerError(request, error)
            : HttpResponse.json({
                  unverifiedPhoneContact: {
                      countryCode: '+1',
                      number: '5555555555'
                  }
              });
    }
);

const enrollmentPhoneSkipMutation = http.post(apiUrl(AuthApiPaths.enrollmentPhoneSkip), () =>
    HttpResponse.json(undefined, { status: 204 })
);

const enrollmentPhoneSubmitMutation = http.post<PathParams, { passcode: string }>(
    apiUrl(AuthApiPaths.enrollmentPhoneSubmit),
    async ({ request }) => {
        const body = await request.json();
        const error = validateOtp(body.passcode);
        return error ? composeServerError(request, error) : new HttpResponse();
    }
);

const enrollmentPhoneInitMutation = http.post(apiUrl(AuthApiPaths.enrollmentPhoneInit), () =>
    HttpResponse.json({ contactId: phoneContact.contactId })
);
const invitationWithoutLocaleQuery = http.get(apiUrl(AuthApiPaths.invitation), () =>
    HttpResponse.json(invitationWithoutLocale)
);
const enrollmentInvitationMutation = http.post(apiUrl(AuthApiPaths.enrollmentInvitation), () =>
    HttpResponse.json(invitation)
);

export const enrollmentHandlers = [
    invitationWithoutLocaleQuery,
    enrollmentInvitationMutation,
    enrollmentOtpSubmitMutation,
    enrollmentPhoneSkipMutation,
    enrollmentPhoneSubmitMutation,
    enrollmentPhoneInitMutation,
    enrollmentAuthenticatorVerifyMutation,
    enrollmentPasswordSubmitMutation,
    enrollmentEmailInitMutation,
    enrollmentAuthenticatorRegisterMutation
];
